import { createSelector } from 'reselect';
import { jobHelpers } from '@saucelabs/sl-util-helpers';

import { FAILURE_ANALYSIS_EXPERIMENT } from './constants';

const builds = (store) => store.apps.builds;

const containerSelector = createSelector([
  builds,
  (store) => store.user,
  (store) => store.experiments,
],
(filteredState, user, experiments) => ({
  loading: filteredState.get('loading'),
  build: filteredState.get('build'),
  failureAnalysisEnabled:
    experiments.get(FAILURE_ANALYSIS_EXPERIMENT) === FAILURE_ANALYSIS_EXPERIMENT,
  jobs: filteredState.get('jobs'),
  truncated: filteredState.get('truncated'),
  isOpenSauceUser: !user.isAuthenticated(),
  isOwner: filteredState.getIn(['build', 'owner']) === user.get('username'),
}));

const stopBuildSelector = createSelector([
  builds,
], (filteredState) => {
  const [...runningJobsIds] = filteredState.get('jobs')
    .filter((job) => jobHelpers.getStatus(job.get('status')) === 'running')
    .keys();

  return ({
    buildOwner: filteredState.getIn(['build', 'owner']),
    runningJobsIds,
  });
});

export default containerSelector;
export {
  containerSelector,
  stopBuildSelector,
  builds,
};
